import CityPageTemplate from "../city-template/CityPageTemplate";
import { newmarketConfig } from "./data";

export default function NewmarketPage() {
  return <CityPageTemplate config={newmarketConfig} />;
}